import { useEffect, useRef, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { fetchAllCatalogs } from '@/redux/slices/catalogs/catalogsSlices';
import { fetchAllUsers } from '@/redux/slices/users/usersSlices';
import { fetchAllCompany } from '@/redux/slices/company/companySlices';
import { useDispatch, useSelector } from 'react-redux';
import { Toast } from 'primereact/toast';
import { selectUserData } from '@reduxSlices/user/userSlices';
import { fetchProduct } from '@/redux/slices/product/productSlices';
import moment from 'moment';
import 'moment-timezone';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import Goods from './Goods';
import config from '@/config';
import './styles.scss';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
moment.tz.setDefault('Europe/Kiev');

const Product = () => {
  const { id } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();
  const [products, setProducts] = useState([]);
  const [selectCompany, setSelectCompany] = useState(null);
  const [capacity, setCapacity] = useState(null);
  const [comment, setComment] = useState('');
  const { isEditing } = location.state ?? {};
  const navigate = useNavigate();
  const { allCatalogs } = useSelector((state) => state.catalogs);
  const { role, login: userLogin, _id: userId, company_id: userCompanyId } = useSelector(selectUserData) ?? {};
  const { allCompany } = useSelector((state) => state.company);
  const { data, status, error } = useSelector((state) => state.product) ?? {};
  const toast = useRef(null);
  const formikRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { API_URL } = config;
  const productId = data?._id;

  const addProduct = (product) => {
    setProducts([...products, product]);
  };

  const removeProduct = (iteration) => {
    setProducts(products.filter(({ id }) => id !== iteration));
  };

  const changeCopacity = (value) => {
    setCapacity(value);
  };

  const gradeItems =
    allCatalogs?.['grade']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      .map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const companyItems =
    allCompany.map(({ name, _id }) => ({
      label: name,
      value: _id,
    })) ?? [];

  const storagesItems =
    allCatalogs?.['storages']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      .map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const gangItems =
    allCatalogs?.['gang']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      ?.map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const supplierItems =
    allCatalogs?.['suppliers']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      ?.map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const productsItems =
    allCatalogs?.['products']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      .map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const carriersItems =
    allCatalogs?.['carriers']
      ?.filter((item) => [userCompanyId, selectCompany].includes(item?.company_id))
      .map(({ name, _id }) => ({
        label: name,
        value: _id,
      })) ?? [];

  const ProductSchema = Yup.object().shape({
    ...(role === 'admin'
      ? {
          company: Yup.string().required('Виберіть компанію'),
        }
      : {}),
    gang: Yup.string().required('Виберіть зміну'),
    supplier: Yup.string().required('Виберіть постачальника'),
    storage: Yup.string().required('Виберіть склад'),
    carrier: Yup.string().required('Виберіть перевізника'),
    comment: Yup.string().min(2, 'Занадто короткий!').max(150, 'Занадто довгий!'),
  });
  const handleSubmitForm = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const renameKeys = (id, arr) => {
    try {
      const obj = arr.find((item) => item.value === id);
      return { _id: obj?.value, title: obj?.label };
    } catch (error) {
      console.log('error', error);
      return {};
    }
  };

  const calculateCustomValue = (products, capacity) => {
    if (products?.length) {
      return (capacity / products?.length).toFixed(2);
    }
    return 0;
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    setLoading(true);

    try {
      const token = localStorage.getItem('authToken');
      const company = allCompany.find(({ _id }) => _id === values.company);

      const dataProducts = products.map((product) => ({
        ...product,
        capacity: calculateCustomValue(products, capacity),
      }));

      const data = {
        carrier: renameKeys(values.carrier, carriersItems),
        gang: renameKeys(values.gang, gangItems),
        storage: renameKeys(values.storage, storagesItems),
        supplier: renameKeys(values.supplier, supplierItems),
        company_id: company?._id,
        company_name: company?.name,
        comment,
        user: {
          title: userLogin,
          _id: userId,
        },
        capacity,
        products: dataProducts,
        ...(isEditing ? { _id: productId } : {}),
      };

      const response = await fetch(`${API_URL}/product`, {
        method: isEditing ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok || response.status !== 200) {
        throw new Error('Server error!');
      }
      const body = await response.json();

      toast.current.show({
        severity: 'info',
        summary: `${isEditing ? 'Оновлено' : 'Додано'}`,
        detail: `${isEditing ? 'Дані успішно оновлено.' : 'Документ приймання створено'}`,
        life: 3000,
      });

      setLoading(false);

      if (!isEditing) {
        navigate(`/products/${body?.data?._id}`, { state: { isEditing: true } });
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }

    setSubmitting(false);
  };

  useEffect(() => {
    if (id !== 'new') {
      dispatch(fetchProduct(id));
    }
  }, [id]);

  useEffect(() => {
    dispatch(fetchAllCompany());
    dispatch(fetchAllCatalogs());
    dispatch(fetchAllUsers());
  }, []);

  useEffect(() => {
    if (id === 'new') {
      role === 'admin' ? setSelectCompany(allCompany[0]?._id) : setSelectCompany('');
    } else if (data) {
      role === 'admin' ? setSelectCompany(data?.company_id) : setSelectCompany('');
    }
    if (data) {
      setComment(data?.comment);
      setProducts(data?.products);
      setCapacity(data?.capacity);
    }
  }, [allCompany, data]);

  useEffect(() => {
    if (status === 'failed') {
      toast.current.show({ severity: 'error', summary: 'Error', detail: `${error}`, life: 5000 });
    }
  }, [error, status]);

  return (
    <div className='page'>
      <h2 className='page__title'>Документ приймання</h2>
      <div className='page__form'>
        <div className='page__form-title'>
          <p>Дата прийняття: {moment(data?.created_at).format('DD.MM.YYYY')}</p>
          {id !== 'new' && <p>Документ: №{data?.document_no}</p>}
        </div>
        {(data || id === 'new') && (role === 'admin' ? !!selectCompany : true) && (
          <>
            <Formik
              initialValues={{
                ...(role === 'admin'
                  ? {
                      company: selectCompany,
                    }
                  : {}),
                gang: data?.gang?._id,
                supplier: data?.supplier?._id,
                storage: data?.storage?._id,
                carrier: data?.carrier?._id,
                comment: data?.comment,
              }}
              validationSchema={ProductSchema}
              onSubmit={handleSubmit}
              innerRef={formikRef}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form>
                  <div className='m-0 form'>
                    {role === 'admin' && (
                      <div className='form__elem'>
                        <span className='p-float-label'>
                          <Field name='company' className={errors.company && touched.company ? 'p-invalid' : ''}>
                            {({ field }) => (
                              <Dropdown
                                value={field.value}
                                options={companyItems ?? []}
                                disabled={id !== 'new'}
                                onChange={(e) => {
                                  setSelectCompany(e.value);
                                  setFieldValue('company', e.value);
                                }}
                              />
                            )}
                          </Field>
                          <label htmlFor='company'>Підриємство</label>
                        </span>
                        {errors.company && touched.company ? (
                          <small id='company-help' className='p-error'>
                            {errors.company}
                          </small>
                        ) : null}
                      </div>
                    )}
                    <div className='flex align-items-start justify-content-between gap-3 form__elem-wrap'>
                      <div className='form__elem'>
                        <span className='p-float-label'>
                          <Field name='gang' className={errors.gang && touched.gang ? 'p-invalid' : ''}>
                            {({ field }) => (
                              <Dropdown
                                value={field.value}
                                options={gangItems ?? []}
                                onChange={(e) => setFieldValue('gang', e.value)}
                                emptyMessage='Немає змін'
                              />
                            )}
                          </Field>
                          <label htmlFor='gang'>Зміна</label>
                        </span>
                        {errors.gang && touched.gang ? (
                          <small id='gang-help' className='p-error'>
                            {errors.gang}
                          </small>
                        ) : null}
                      </div>
                      <div className='form__elem'>
                        <span className='p-float-label'>
                          <Field name='storage' className={errors.storage && touched.storage ? 'p-invalid' : ''}>
                            {({ field }) => (
                              <Dropdown
                                value={field.value}
                                options={storagesItems ?? []}
                                onChange={(e) => setFieldValue('storage', e.value)}
                                emptyMessage='Немає складів'
                              />
                            )}
                          </Field>
                          <label htmlFor='storage'>Склад</label>
                        </span>
                        {errors.storage && touched.storage ? (
                          <small id='storage-help' className='p-error'>
                            {errors.storage}
                          </small>
                        ) : null}
                      </div>
                    </div>
                    <div className='flex align-items-start justify-content-between gap-3 form__elem-wrap'>
                      <div className='form__elem'>
                        <span className='p-float-label'>
                          <Field name='supplier' className={errors.supplier && touched.supplier ? 'p-invalid' : ''}>
                            {({ field }) => (
                              <Dropdown
                                value={field.value}
                                options={supplierItems ?? []}
                                filter
                                onChange={(e) => setFieldValue('supplier', e.value)}
                                emptyMessage='Немає постачальників'
                              />
                            )}
                          </Field>
                          <label htmlFor='supplier'>Постачальник</label>
                        </span>
                        {errors.supplier && touched.supplier ? (
                          <small id='supplier-help' className='p-error'>
                            {errors.supplier}
                          </small>
                        ) : null}
                      </div>
                      <div className='form__elem'>
                        <span className='p-float-label'>
                          <Field name='carrier' className={errors.carrier && touched.carrier ? 'p-invalid' : ''}>
                            {({ field }) => (
                              <Dropdown
                                value={field.value}
                                filter
                                options={carriersItems ?? []}
                                onChange={(e) => setFieldValue('carrier', e.value)}
                                emptyMessage='Немає перевізників'
                              />
                            )}
                          </Field>
                          <label htmlFor='carrier'>Перевізник</label>
                        </span>
                        {errors.carrier && touched.carrier ? (
                          <small id='carrier-help' className='p-error'>
                            {errors.carrier}
                          </small>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
            <Goods
              gradeItems={gradeItems}
              productsItems={productsItems}
              products={products}
              addProduct={addProduct}
              removeProduct={removeProduct}
              capacity={capacity}
              changeCopacity={changeCopacity}
            />
            <div className='form__elem'>
              <span className='p-float-label'>
                <InputTextarea
                  rows={5}
                  cols={30}
                  value={comment}
                  onChange={(e) => {
                    setComment(e.target.value);
                  }}
                  style={{ width: '100%' }}
                />
                <label htmlFor='comment'>Коментар</label>
              </span>
            </div>
            <Button
              type='button'
              loading={loading}
              className='form__button'
              label={isEditing ? 'Зберегти' : 'Створити'}
              icon='pi pi-check'
              autoFocus
              onClick={handleSubmitForm}
              style={{ display: 'block', margin: 'auto' }}
            />
          </>
        )}
      </div>
      <Toast ref={toast} />
    </div>
  );
};

export default Product;
